export default {
  en: {
    'components.summary-table.data-row.troubleshoot-tooltip': 'Troubleshoot',
  },
};
